import { render } from "./CabeceraComponentBackSearch.vue?vue&type=template&id=456f7dc0&scoped=true"
import script from "./CabeceraComponentBackSearch.vue?vue&type=script&lang=js"
export * from "./CabeceraComponentBackSearch.vue?vue&type=script&lang=js"

import "./CabeceraComponentBackSearch.vue?vue&type=style&index=0&id=456f7dc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456f7dc0"]])

export default __exports__